import type { ProductVariant } from '~~/types/commercetools';
import { PRODUCT_ATTRIBUTES } from '~~/constants/products';
import {
  getProductAttributesExtended,
} from '~~/helpers/product/getProductAttributesExtended';
import { isBWareProduct } from '~~/helpers/product/productCondition';

export const getAlternativeProductFilter = (product: ProductVariant): string | undefined => {

  const sku = product.sku;
  const isBware = isBWareProduct(sku);
  const family = getProductAttributesExtended(
    product,
    {
      attributeNames: [PRODUCT_ATTRIBUTES.FAMILY],
    })[PRODUCT_ATTRIBUTES.FAMILY];

  if (!sku || !family) {

    return;
  
  }

  const isBwareFilter = isBware ? ` and attributes((name="isBware" and value=${isBware})) ` : '';

  return ` and masterData(current(masterVariant(
    attributes((name="family" and value="${family}"))
    ${isBwareFilter} and
    sku != "${sku}"
  )))`;

};
